Vue.component(//问答首页
    'crowd-testing-index',
    resolve => require(["../../components/crowdTesting/index.vue"], resolve)
);

Vue.component(//问答首页
    'crowd-testing-header',
    resolve => require(["../../components/crowdTesting/header.vue"], resolve)
);

Vue.component(//问答首页
    'crowd-testing-instructions',
    resolve => require(["../../components/crowdTesting/instructions.vue"], resolve)
);

Vue.component(//问答首页
    'crowd-testing-winners',
    resolve => require(["../../components/crowdTesting/winners.vue"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/crowdTesting.js